import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';
@Injectable()
export class BankService {

  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) { }

  getList() {
    return this.httpClient.get(`${this.rootUrl}/api/Bank/GetList`);
  }
  update(objBank: any) {
    return this.httpClient.put(`${this.rootUrl}/api/Bank/Put`, objBank);
  }
  delete(bankNumber: number) {
    return this.httpClient.delete(`${this.rootUrl}/api/Bank/Delete?bankNumber=${bankNumber}`);
  }
  post(bank: any) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/Bank/Post`, bank, { headers });
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/bank.service.ts